import { SplitType } from '../../invitations/models/invitation.model';

/**
 * Auto-generate criteria for the in-invitation "Create groups" popup, mapped onto our split
 * algorithms. Defined once.
 *
 * Since v16.2.082 these two ARE the whole of `SplitType` — the popup and the standalone wizard
 * offer the same choice, so this list no longer narrows anything. It stays because the popup's
 * labels ("Similar Profiles" / "Mixed") differ from the wizard's ("Similar Preference" /
 * "Diverse Preference: Exact").
 */
export interface SelectionCriterion { key: 'like' | 'unlike'; label: string; desc: string; splitType: SplitType; }

export const SELECTION_CRITERIA: SelectionCriterion[] = [
  { key: 'like',   label: 'Similar Profiles', desc: 'Group members with similar thinking preferences', splitType: 'similar' },
  { key: 'unlike', label: 'Mixed',            desc: 'Group members with diverse thinking preferences', splitType: 'diverse_exact' },
];
